import {
    ANNIVERSARY_DAYS_THRESHOLD,
    isExcludedScreen,
    isFreePlanUser,
    type TSessionDialogContext,
    type TSessionDialogVerdict,
} from '@core/session-dialogs'

const MS_PER_DAY = 1000 * 60 * 60 * 24

export const daysSinceJoining = ({ now, joinDate }: { now: number; joinDate: number }): number =>
    Math.floor((now - joinDate) / MS_PER_DAY)

export const shouldShowAnniversaryPromo = (
    context: TSessionDialogContext,
): TSessionDialogVerdict => {
    if (context.seenAnniversaryPromo) {
        return false
    }

    const isEligible = isFreePlanUser(context)

    if (isEligible !== true) {
        return isEligible
    }

    if (!context.joinDate) {
        return false
    }

    if (isExcludedScreen(context.screenId)) {
        return false
    }

    if (daysSinceJoining(context) < ANNIVERSARY_DAYS_THRESHOLD) {
        return false
    }

    if (!context.lcpRecorded) {
        return 'pending'
    }

    return true
}
